export default {
  cardHeaderStyle: {
    fontFamily: "Roboto",
    margin: "1rem 0 0 1rem",
    fontSize: "1.5rem",
    letterSpacing: "0.1rem",
  },

  imageStyle: {
    width: "6rem",
    height: "6rem",
  },

  titleContainerStyle: {
    display: "flex",
    justifyContent: "space-around" as "space-around",
    cursor: "pointer",
  },
};
